// Serializable user model for NgRx store
export interface SerializableUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  phoneNumber: string | null;
  photoURL: string | null;
  emailVerified: boolean;
}

// Helper function to convert Firebase User to serializable format
export function toSerializableUser(user: any): SerializableUser | null {
  if (!user) {
    return null;
  }

  return {
    uid: user.uid || '',
    email: user.email || null,
    displayName: user.displayName || null,
    phoneNumber: user.phoneNumber || null,
    photoURL: user.photoURL || null,
    emailVerified: user.emailVerified || false,
  };
}

